import { render, staticRenderFns } from "./AccountingPlanSelection.vue?vue&type=template&id=20f2ef25&"
import script from "./AccountingPlanSelection.vue?vue&type=script&lang=js&"
export * from "./AccountingPlanSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports